import * as types from "../types";

const initialState = {
  analyticsCallTableData: [],
  analyticsCallDataEvening: [],
  analyticsCallDataINC: [],
  analyticsTableUnansweredProperties: {
    next: null,
    previous: null,
    totalCount: null,
    results: [],
  },
  analyticsTableProperties: {
    next: null,
    previous: null,
    totalCount: null,
    results: [],
  },
  unansweredTableProperties: {},
  callBreakDownData: {},
  callBreakDownDataINC: {},
  isDataUpdated: false,
  isError: false,
};

export default function analytics(
  state = initialState,
  { type, payload } = {}
) {
  switch (type) {
    case types.GET_ANALYTICS_DATA_SUCCESS:
      return {
        ...state,
        isError: false,
        analyticsCallTableData: payload.results,
        analyticsTableProperties: {
          ...state.analyticsTableProperties,
          ...payload,
        },
        isDataUpdated: false,
      };

    case types.GET_ANALYTICS_DATA_FAILED:
      return {
        ...state,
        isError: true,
        analyticsCallTableData: [],
        isDataUpdated: false,
      };
    case types.GET_ANALYTICS_DATA_SUCCESS_EVN:
      return {
        ...state,
        isError: false,
        analyticsCallDataEvening: payload,
        isDataUpdated: false,
      };

    case types.GET_ANALYTICS_DATA_FAILED_EVN:
      return {
        ...state,
        isError: true,
        analyticsCallDataEvening: [],
        isDataUpdated: false,
      };
    case types.GET_ANALYTICS_UNANSWERED_DATA_SUCCESS:
      return {
        ...state,
        isError: false,
        analyticsTableUnansweredProperties: {
          ...state.analyticsTableUnansweredProperties,
          ...payload,
        },
        isDataUpdated: false,
      };
      case types.GET_ANALYTICS_UNANSWERED_DATA_FAILED:
        return {
          ...state,
          isError: true,
          analyticsTableUnansweredProperties: {
            ...state.analyticsTableUnansweredProperties,
          },
          isDataUpdated: false,
        };
    case types.GET_ANALYTICS_CALL_BREAK_DOWN_DATA_SUCCESS:
      return {
        ...state,
        isError: false,
        callBreakDownData: payload,
        isDataUpdated: false,
      };

    case types.GET_ANALYTICS_CALL_BREAK_DOWN_DATA_FAILED:
      return {
        ...state,
        isError: true,
        callBreakDownData: {},
        isDataUpdated: false,
      };
    case types.PUT_EDIT_ANALYTICS_DATA_SUCCESS:
      return {
        ...state,
        isError: false,
        isDataUpdated: payload.isDataUpdated,
      };
    case types.PUT_EDIT_ANALYTICS_DATA_FAILED:
      return {
        ...state,
        isError: false,
        isDataUpdated: false,
      };

    case types.GET_ANALYTICS_DATA_INC_SUCCESS:
      return {
        ...state,
        isError: false,
        analyticsCallDataINC: payload,
        isDataUpdated: false,
      };

    case types.GET_ANALYTICS_DATA_INC_FAILED:
      return {
        ...state,
        isError: true,
        analyticsCallDataINC: [],
        isDataUpdated: false,
      };
    case types.GET_ANALYTICS_CALL_BREAK_DOWN_DATA_INC_SUCCESS:
      return {
        ...state,
        isError: false,
        callBreakDownDataINC: payload,
        //callBreakDownDataINC: {"callAnalytics":{"answered":70,"successfulCall":70,"callCompleted":59,"callIncompleted":11,"totalCallAttempt":70,"totalCall":70,"totalUnanswered":0},"dispositionAnalytics":{"Partial_Payment":3,"null":2,"Promise_to_Pay":9,"Refused_to_Pay":3,"Agree_to_Pay":1},"delayReasonAnalytics":{"job_loss":2,"null":12,"medical_issue":4}},
        isDataUpdated: false,
      };

    case types.GET_ANALYTICS_CALL_BREAK_DOWN_DATA_INC_FAILED:
      return {
        ...state,
        isError: true,
        callBreakDownDataINC: {},
        isDataUpdated: false,
      };
    default:
      return state;
  }
}
